import beaconUrl from './analytics-beacon.js?url';

const SCREEN_PATHS = {
  home: '/', find: '/find', property: '/property', saved: '/saved', designs: '/designs', draw: '/draw',
} as const;

export type Screen = keyof typeof SCREEN_PATHS;
type AnalyticsPath = (typeof SCREEN_PATHS)[Screen];

declare global {
  interface Window {
    dairyoakAnalyticsPagePath?: AnalyticsPath;
    dairyoakAnalytics?: {
      trackPageview: (path: AnalyticsPath) => boolean;
      flush: () => boolean;
    };
  }
}

let loading = false;

/** Called after React commits a screen, never with URLs, resource IDs or content. */
export function trackScreen(screen: Screen): void {
  try {
    const path = SCREEN_PATHS[screen];
    if (!path) return;
    window.dairyoakAnalyticsPagePath = path;
    if (window.dairyoakAnalytics) {
      window.dairyoakAnalytics.trackPageview(path);
    } else if (!loading) {
      loading = true;
      const script = document.createElement('script');
      script.src = beaconUrl;
      script.async = true;
      script.onerror = () => { loading = false; script.remove(); };
      document.head.appendChild(script);
    }
  } catch {
    // Restricted storage, blocked scripts or analytics must not affect the app.
  }
}
